module.exports = __webpack_public_path__ + "static/media/icon-school.71d5ad4f.svg";